import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Forgot from '../views/Forgot.vue'
import Photography from '../views/Photography.vue'
import Vector from '../views/Vector.vue'
import Video from '../views/Video.vue'
import UserCenter from '../views/UserCenter.vue'
import Dashboard from '../views/Dashboard.vue'
import Search from '../views/Search.vue'
import Search_author from "../views/Search_author";
import VideoList from '../views/VideoList.vue'
import Photo from '../views/Photo.vue'
import VideoDetail from '../views/VideoDetail.vue'
import PersonalCenter from '../views/PersonalCenter.vue'
import ReverseSearch from '../views/ReverseSearch.vue'
import Register from "@/views/Register";
import Index from "../views/Index";
import Special_list from "../views/Special_list";
import Special_detail from "../views/Special_detail";

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect:{name:'Index'}
    }, {
      path: '/login',
      name: 'Login',
      component: Login,
      meta:{
        auth:false,
        title:'神笔Pro - 登录'
      }
    }, {
      path: '/forgot',
      name: 'Forgot',
      component: Forgot,
      meta:{
        auth:false,
        title:'神笔Pro - 忘记密码'
      }
    },{
      path: '/register',
      name: 'Register',
      component: Register,
      meta:{
        auth:false,
        title:'神笔Pro - 注册'
      }
    },
    {
      path: '/photography',
      name: 'Photography',
      component: Photography,
      meta:{
        auth:false,
        title:'神笔Pro - 正版摄影图片,矢量图片,视频素材 - 企业高级授权服务'
      }
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      meta:{
        auth:false,
        title:'神笔Pro - 正版摄影图片,矢量图片,视频素材 - 企业高级授权服务'
      }
    },
    {
      path: '/special_list',
      name: 'Special_list',
      component: Special_list,
      meta:{
        auth:false,
        title:'神笔Pro - 正版摄影图片,矢量图片,视频素材 - 企业高级授权服务'
      }
    },{
      path: '/special_detail',
      name: 'Special_detail',
      component: Special_detail,
      meta:{
        auth:false,
        title:'神笔Pro - 正版摄影图片,矢量图片,视频素材 - 企业高级授权服务'
      }
    },{
      path: '/vector',
      name: 'Vector',
      component: Vector,
      meta:{
        auth:false,
        title:'神笔Pro - 正版摄影图片,矢量图片,视频素材 - 企业高级授权服务'
      }
    }, {
      path: '/video',
      name: 'Video',
      component: Video,
      meta:{
        auth:false,
        title:'神笔Pro - 正版摄影图片,矢量图片,视频素材 - 企业高级授权服务'
      }
    }, {
      path: '/userCenter',
      name: 'UserCenter',
      component: UserCenter,
      redirect: '/userCenter/buyMaterial',
      meta:{
        auth:true,
        title:'神笔Pro - 用户中心'
      },children: [
        {
          path: 'buyMaterial',
          component: () => import('@/views/userCenter/buyMaterial'),
          name: 'buyMaterial',
          single: true,
          meta:{
            auth:true,
            title:'神笔Pro - 已购素材'
          }
        },
        {
          path: 'smallRecord',
          component: () => import('@/views/userCenter/smallRecord'),
          name: 'smallRecord',
          single: true,
          meta:{
            auth:true,
            title:'神笔Pro - 小样记录'
          }
        },
        {
          path: 'browseRecord',
          component: () => import('@/views/userCenter/browseRecord'),
          name: 'browseRecord',
          single: true,
          meta:{
            auth:true,
            title:'神笔Pro - 浏览记录'
          }
        },
        {
          path: 'myCollection',
          component: () => import('@/views/userCenter/myCollection'),
          name: 'myCollection',
          single: true,
          meta:{
            auth:true,
            title:'神笔Pro - 我的收藏'
          }
        }
      ]
    }, {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      redirect: '/dashboard/overview',
      meta:{
        auth:true,
        title:'神笔Pro - 控制面板'
      },
      children: [
        {
          path: 'overview',
          component: () => import('@/views/dashboard/Overview'),
          name: 'overview',
          single: true,
          meta:{
            auth:true,
            title:'神笔Pro - 信息汇总'
          }
        },
        {
          path: 'authorization',
          component: () => import('@/views/dashboard/Authorisation'),
          name: 'authorisation',
          single: true,
          meta:{
            auth:true,
            title:'神笔Pro - 授权信息'
          }
        },
        {
          path: 'user',
          component: () => import('@/views/dashboard/User'),
          name: 'user',
          single: true,
          meta:{
            auth:true,
            title:'神笔Pro - 用户管理'
          }
        },
        {
          path: 'download',
          component: () => import('@/views/dashboard/DownloadLog'),
          name: 'download',
          single: true,
          meta:{
            auth:true,
            title:'神笔Pro - 下载历史'
          }
        },
        {
          path: 'log',
          component: () => import('@/views/dashboard/OperationLog'),
          name: 'log',
          single: true,
          meta:{
            auth:true,
            title:'神笔Pro - 使用记录'
          }
        },
        {
          path: 'affiliation',
          component: () => import('@/views/dashboard/AffiliatedCompany'),
          name: 'affiliation',
          single: true,
          meta:{
            auth:true,
            title:'神笔Pro - 关联企业'
          }
        }
      ]
    }, {
      path: '/search',
      name: 'Search',
      component: Search,
      meta:{
        auth:false,
        title:'神笔Pro - 搜索'
      }
    },
    {
      path: '/search_author',
      name: 'Search_author',
      component: Search_author,
      meta:{
        auth:false,
        title:'神笔Pro - 搜索'
      }
    },{
      path: '/reverse-search',
      name: 'ReverseSearch',
      component: ReverseSearch,
      meta:{
        auth:false,
        title:'神笔Pro - 以图搜图'
      }
    },{
      path: '/personalCenter',
      name: 'PersonalCenter',
      component: PersonalCenter,
      meta:{
        auth:true,
        title:'个人中心'
      }
    }, {
      path: '/videoList',
      name: 'VideoList',
      component: VideoList,
      meta:{
        auth:false,
        title:'神笔Pro - 搜索'
      }
    }, {
      path: '/photo',
      name: 'Photo',
      component: Photo,
      meta:{
        auth:false,
        title:'神笔Pro - 图片详情'
      }
    }, {
      path: '/video_detail',
      name: 'VideoDetail',
      component: VideoDetail,
      meta:{
        auth:false,
        title:'神笔Pro - 视频详情'
      }
    }
    ]
})
